import React from "react";
import Header from "../../../components/Header/Header";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography,
} from "@mui/material";
import Footer from "../../../components/Footer";
import { useEffect, useState } from "react";
import * as acts from "../../../redux/pre_processor/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../../../components/ProgressBar";
import "./newProject.scss";
import CustomizedSnackbar from "../../../components/Snackbars/CustomizedSnackbars";
import ProjectStepper from "../../../components/Stepper/ProjectStepperCpvAuto";
import { Select, Box, TextField, MenuItem } from "@mui/material";
import { notification } from "../../../constants/notificationMessages";
import constants from "../../../constants/constantValues";
import ProjectHeader from "../../../components/Header/ProjectHeader";
import { preProRoutes } from "../../../routes/routeConstants";

const NewProject = (props) => {
  const [projectName, setProjectName] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [createProjectSuccess, setCreateProjectSuccess] = useState(false);
  const [createProjectError, setCreateProjectError] = useState(false);
  const [message, setMessage] = useState("");
  const [invalidValidationErrorMessage, setInvalidValidationErrorMessage] =
    useState("");
  const [drugType, setDrugType] = useState("");
  const [buttonType, setButtonType] = useState("");
  const apiStatus = useSelector((state) => state?.prePro?.apiStatus);
  const fileType = useSelector((state) => state?.prePro?.folderType);
  const [projectType, setProjectType] = useState("");
  const { PROJECT_NAME, DRUG_TYPE } = constants;

  useEffect(() => {
    //Success and error notification
    if (apiStatus.apiSuccess === true && buttonType === "continue") {
      setCreateProjectSuccess(true);
      setMessage(apiStatus.message);
      setTimeout(() => {
        navigate(`/${preProRoutes.uploadBatchRecord}`) 
      }, 2000);
    } else if (apiStatus.apiError === true) {
      setMessage(apiStatus.message);
      setInvalidValidationErrorMessage(true);
      setCreateProjectError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiStatus]);

  useEffect(() => {
    dispatch(acts.getDrugType());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleprojectName = (event, action) => {
    //new project creation and validation
    setInvalidValidationErrorMessage("");
    setProjectName(event.target.value);
    setInvalidValidationErrorMessage(false);
  };
  const handleSubmit = async (event, action) => {
    // localStorage.setItem("mapData", false);
    localStorage.setItem("template_mapping_status", "not_started");
    localStorage.setItem("qc_mapping_status", "not_started");
    setButtonType(action);
    event.preventDefault();
    if (action === "previous") {
      navigate(`/${preProRoutes.preProDashboard}`)  
    }
    if (/[^a-zA-Z0-9_ -]/.test(projectName)) {
      setInvalidValidationErrorMessage(
        notification.invalidValidationErrorMessage
      );
    } else if (action === "save") {
      dispatch(acts.createNewProject(projectName, drugType, true, projectType));
    } else if (action === "continue") {
      dispatch(acts.createNewProject(projectName, drugType, true, projectType));
      setInvalidValidationErrorMessage("");
    }
    localStorage.removeItem("isCloned");
  };
  const handleFolderChange = (event) => {
    setDrugType(event.target.value);
    localStorage.setItem("drugType", event.target.value);
  };

  const handleChange = (event) => {
    setProjectType(event.target.name);
  };

  return (
    <React.Fragment>
      <Header page="new-project" />
      <ProjectStepper currentStep={0} />
      <ProjectHeader
        headerColor={"#F5F5F5"}
        text={
          (projectName ? projectName : "Project Name") +
          "-" +
          (drugType ? drugType : "Drug Type")
        }
        position="center"
      />
      <Box>
        <Grid container className="new-project-wrap">
          <Grid item md={3} className="project-info">
            <Typography className="subtitle2" variant="subtitle2">
              {PROJECT_NAME}
            </Typography>

            {/* <h6 className="subtitle2">{PROJECT_NAME}</h6> */}
            <TextField
              fullWidth
              className="new-project"
              placeholder={PROJECT_NAME}
              helperText={invalidValidationErrorMessage}
              error={invalidValidationErrorMessage}
              onChange={(event, action) => handleprojectName(event, action)}
            />
          </Grid>

          <Grid item md={3} className="project-info">
            {/* <h6 className="subtitle2"></h6> */}

            <Typography className="subtitle2" variant="subtitle2">
              {DRUG_TYPE}{" "}
            </Typography>

            <Select
              fullWidth
              value={drugType}
              disabled={projectName === ""}
              onChange={handleFolderChange}
            >
              {fileType &&
                fileType.length > 0 &&
                fileType.map((value) => (
                  <MenuItem value={value.name} key={value?.name}>
                    {value.name}
                  </MenuItem>
                ))}
            </Select>
          </Grid>
        </Grid>

        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: 4,
            }}
          >
            <FormControl component="fieldset" variant="standard">
              <Typography
                // className="subtitle2"
                variant="subtitle2"
                // textAlign={"center"}
              >
                Project Type
              </Typography>

              <FormGroup column>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={projectType === "both"}
                      onChange={handleChange}
                      name="both"
                    />
                  }
                  label="Both"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={projectType === "free_form"}
                      onChange={handleChange}
                      name="free_form"
                    />
                  }
                  label="Quality Control"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={projectType === "template_driven"}
                      onChange={handleChange}
                      name="template_driven"
                    />
                  }
                  label="Extraction"
                />
              </FormGroup>
            </FormControl>
          </Box>
        </Box>
      </Box>
      <Footer
        isNextDisable={
          projectName !== "" && drugType !== "" && projectType !== ""
            ? false
            : true
        }
        isPrevious={false}
        isNext={false}
        onHandleClick={(event, action) => handleSubmit(event, action)}
      />

      <div>
        {apiStatus && apiStatus.loader ? <ProgressBar /> : ""}

        {createProjectSuccess && (
          <CustomizedSnackbar
            severity="success"
            state={createProjectSuccess}
            text={message}
            handleClose={() => setCreateProjectSuccess(false)}
          />
        )}

        {createProjectError && (
          <CustomizedSnackbar
            severity="error"
            state={createProjectError}
            text={message}
            handleClose={() => setCreateProjectError(false)}
          />
        )}
      </div>
    </React.Fragment>
  );
};
export default NewProject;
